import { useNavigate, useSearchParams, NavigateOptions } from "react-router-dom";

type WhitelistedParams = "ref" | "guildId" | "challengeId" | "frame_id";
const PARAMS_WHITELIST: Array<WhitelistedParams> = ["ref", "guildId", "challengeId", "frame_id"];

const useNavigateWithParams = (params?: Array<WhitelistedParams>): ((path: string, options?: NavigateOptions) => void) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const navigateWithParams = (path: string, options: NavigateOptions = {}): void => {
        const paramsToKeep: Record<string, string> = {};
        [...PARAMS_WHITELIST, ...params ?? []].forEach((param) => {
            const value = searchParams.get(param);
            if (value) {
                paramsToKeep[param] = value;
            }
        });
        const url = new URL(path, window.location.origin);
        Object.entries(paramsToKeep).forEach(([key, value]) => {
            url.searchParams.set(key, value);
        });
        navigate(`${url.pathname}${url.search}`, options);
    };
    return navigateWithParams;
};
export default useNavigateWithParams;